// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDaRnlsBWCnXNvThCWHbmQWJhu3LyJTjtI",
    authDomain: "mediacare-hospital.firebaseapp.com",
    projectId: "mediacare-hospital",
    storageBucket: "mediacare-hospital.appspot.com",
    messagingSenderId: "8914839624",
    appId: "1:8914839624:web:10721e9b9821de952b107d"
};

export default firebaseConfig;